import axios from './axios'

function service(endpoint) {

    function fetchPatients() {
        return axios.get(`${endpoint}/patients`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchComponents() {
        return axios.get(`${endpoint}/components`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchMedicines() {
        return axios.get(`${endpoint}/medicines`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchForPatient(pseudonymId, params) {
        return axios.get(`${endpoint}/patients/${pseudonymId}/therapies`, { params: params }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchEngagement(pseudonymId, params) {
        return axios.get(`${endpoint}/patients/${pseudonymId}/engagement`, { params: params }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function storeMedical(data) {
        return axios.post(`${endpoint}/therapies/medical`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchCompliance(id) {
        return axios.get(`${endpoint}/therapies/${id}/compliance`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchComplianceDetails(id, params) {
        return axios.get(`${endpoint}/therapies/${id}/compliance-details`, { params: params }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function lifecycle(id, transition, data) {
        return axios.post(`${endpoint}/therapies/${id}/${transition}`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function activate(id) {
        return lifecycle(id, 'activate');
    }

    function pause(id) {
        return lifecycle(id, 'pause');
    }

    function resume(id) {
        return lifecycle(id, 'resume');
    }

    function abort(id, data) {
        return lifecycle(id, 'abort', data);
    }

    function complete(id) {
        return lifecycle(id, 'complete');
    }

    return {
        fetchPatients,
        fetchComponents,
        fetchMedicines,
        fetchForPatient,
        fetchEngagement,
        storeMedical,
        fetchCompliance,
        fetchComplianceDetails,
        activate,
        pause,
        resume,
        abort,
        complete
    }
}

export default service
